import { render, staticRenderFns } from "./reference-layout.vue?vue&type=template&id=058b16ea&scoped=true&"
import script from "./reference-layout.vue?vue&type=script&lang=js&"
export * from "./reference-layout.vue?vue&type=script&lang=js&"
import style0 from "./reference-layout.vue?vue&type=style&index=0&id=058b16ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b16ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058b16ea')) {
      api.createRecord('058b16ea', component.options)
    } else {
      api.reload('058b16ea', component.options)
    }
    module.hot.accept("./reference-layout.vue?vue&type=template&id=058b16ea&scoped=true&", function () {
      api.rerender('058b16ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/reference-layout.vue"
export default component.exports